<script setup lang="ts">
import { onMounted, ref } from 'vue'

defineProps({
  waveClasses: {
    type: Object,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    default: () => {},
  },
  waveStyles: {
    type: Object,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    default: () => {},
  },
})

const emit = defineEmits(["md-end"])

const animating = ref(false)
onMounted(() => {
  animating.value = true
})

const end = () => {
  animating.value = false
  emit('md-end')
}
</script>

<template>
  <Transition name="md-ripple" appear @after-enter="end">
    <span v-if="animating" />
  </Transition>
</template>
